"use strict";

var $ = require("jquery");
import { navCategoriesSliderToSlide } from './_navCategoriesToSlide.js';

$(document).ready(function () {

    var slider = $('.nav-slider');

    slider.find('.slide').prepend('<div class="btn-prev">' + vars.back + '</div>');
    slider.on('click', '.btn-prev', function (event) {
        navCategoriesSliderToSlide('prev', event);
    });
});